import request from "../request";

export const getCurriculum = (detail) =>
  request.get(detail ? 'curriculum/details' : 'curriculum').then((res) => res);

export const getCurriculumById = (curriculumId) =>
  request.get(`curriculum/${curriculumId}`).then((res) => res);

export const getCurriculumByIdDetail = (curriculumId) =>
  request.get(`curriculum/${curriculumId}/details`).then((res) => res);

export const createCurriculum = (data) =>
  request.post('curriculum', data).then((res) => res);

export const updateCurriculumBasicInformation = (curriculumId, data) =>
  request.put(`curriculum/${curriculumId}/basic-information`, data).then((res) => res);

export const deleteCurriculum = (curriculumId) =>
  request.delete(`curriculum/${curriculumId}`).then((res) => res);
